import {Cursor} from "./cursor";

export interface ISettings
{
    imagePath: string;
    videoPath: string;
    audioPath: string;
}

export class Renderer {
    protected cursor?: Cursor;
    protected muted: boolean = false;

    constructor(protected settings: ISettings)
    {
    }

    public initialise(): Promise<void>
    {
        return Promise.resolve();
    }
    public setCursor(cursor: Cursor)
    {
        this.cursor = cursor;
    }
    public play(): Promise<void>
    {
        return Promise.resolve();
    }
    public pause()
    {
    }
    // Set the render target
    public attach(root: HTMLElement): void
    {
    }
    public update(delta: number): void
    {
    }
    public isMuted() {
        return this.muted;
    }
    public mute() {
        this.muted = true;
    }
    public unmute() {
        this.muted = false;
    }
}